export default __webpack_public_path__ + "static/media/wohnungen_intro_web-md@2x.a6fcb7ce.webp";